
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 10.154V5.338c0-.212-.114-.303-.386-.26l-.011.002-4.634.698a.058.058 0 01-.019.006c-.243.035-.45.155-.45.374V11H5v-.883c.231 0 1-.16 1 .273v2.11c0 .828-.717 1.5-2.25 1.5s-2.25-.672-2.25-1.5.646-1.5 2.25-1.5c.373 0 1.22-.185 1.25-.846V3.43a.5.5 0 01.425-.494l6.5-.98a.5.5 0 01.575.494V12.5c0 .828-.717 1.5-2.25 1.5S8 13.328 8 12.5s.646-1.5 2.25-1.5c.373 0 1.22-.185 1.25-.846z"}})])
          )
        }
      }
    